import { Link } from "react-router-dom";
import { Mountain, Route as RouteIcon, Clock, MapPin, BadgeCheck } from "lucide-react";

export default function RouteCard({ route, featured = false }) {
  return (
    <Link
      to={`/rotas/${route.slug}`}
      data-testid={`route-card-${route.slug}`}
      className="card-rotta group block"
    >
      <div className="img-zoom relative aspect-[4/3] overflow-hidden bg-[#0F0F0F]">
        {route.cover_image && (
          <img
            src={route.cover_image}
            alt={route.name}
            loading="lazy"
            className="w-full h-full object-cover"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B] via-[#0B0B0B]/40 to-transparent" />
        {route.verified && (
          <div className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#0B0B0B]/85 backdrop-blur border border-[#C6A762]/50 text-[#C6A762] text-[10px] tracking-[0.2em] uppercase font-medium">
            <BadgeCheck size={12} /> Rota Verificada
          </div>
        )}
        <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2 text-xs text-white/80">
          <MapPin size={12} className="text-[#C6A762]" />
          <span className="tracking-wider uppercase">{route.state}</span>
        </div>
      </div>

      <div className="p-6 md:p-7">
        <h3 className="font-display text-2xl md:text-[26px] text-white group-hover:text-[#C6A762] transition-colors">
          {route.name}
        </h3>
        <p className="mt-3 text-sm text-[#B8B8B8] leading-relaxed line-clamp-2">
          {route.short_description}
        </p>

        <div className="mt-5 grid grid-cols-3 gap-3 text-xs">
          <Stat icon={<RouteIcon size={14} />} label="Distância" value={`${route.distance_km} km`} />
          <Stat icon={<Mountain size={14} />} label="Dificuldade" value={route.difficulty} />
          <Stat icon={<Clock size={14} />} label="Tempo" value={route.estimated_time} />
        </div>

        <div className="mt-5 flex items-center justify-between">
          <span className="pill">{route.terrain}</span>
          <span className="text-[#C6A762] text-xs tracking-[0.2em] uppercase group-hover:translate-x-1 transition-transform">
            Ver rota →
          </span>
        </div>
      </div>
    </Link>
  );
}

function Stat({ icon, label, value }) {
  return (
    <div className="flex flex-col gap-1 border-l border-[#2a2a2a] pl-3 first:border-l-0 first:pl-0">
      <span className="flex items-center gap-1.5 text-[#C6A762]">{icon}</span>
      <span className="text-[10px] uppercase tracking-[0.2em] text-[#7d7d7d]">{label}</span>
      <span className="text-white font-medium text-[13px]">{value}</span>
    </div>
  );
}
